/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import LocationArrow from "../../assets/images/partners/location-arrow.png";
import LocationColor from "../../assets/images/partners/location-color.png";
export const Marker = ({
  name,
  lat,
  lng,
  idx,
}) => (
  <div
    style={{
      position: "relative",
      height: "46px",
      marginTop: "-46px",
      marginLeft: "-18px",
    }}
  >
    <div
      style={{
        position: "absolute",
        left: "0",
        top: "0",
        padding: "6px 10px",
        border: "2px solid #6DE2A8",
        borderRadius: "24px",
        background: "#fff",
        whiteSpace: "nowrap",
      }}
    >
      <div
        style={{
          width: '11px',
          height: '11px',
          position: 'absolute',
        }}
      />
      <img
        src={LocationArrow}
        style={{
          position: "absolute",
          left: "18px",
          bottom: "-13px",
          width: "12px",
        }}
      />
      <img
        src={LocationColor}
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          marginRight: "4px",
          position: "relative",
          width: "auto",
        }}
      />
      <span
        style={{
          display: "inline-block",
          fontWeight: "800",
          color: "#3d3d3d",
          fontSize: "12px",
          lineHeight: "20px",
          whiteSpace: "nowrap",
        }}
        id={`marker-${idx}`}

      >
        {name}
      </span>
    </div>
  </div>
);
